'use strict';

angular.module('portal.inspections', [])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // portal routings
            // inspections tab
            .state('portal.menus.inspections', {
                url: '/inspections',
                templateUrl: paths.app + 'inspections/components/inspections/inspections.html',
                controller: 'PortalInspections',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.visit', {
                url: '/visit/:id',
                templateUrl: 'templates/inspection-visit/inspection-visit.html',
                controller: 'InspectionVisit',
                params: {
                    id: null,
                    visit: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view('portal.menus.inspections').then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.inspection', {
                url: '/inspection/:id',
                templateUrl: paths.app + 'inspections/components/inspection/inspection.html',
                controller: 'PortalInspection',
                params: {
                    id: null,
                    inspection: null
                },
                data: {
                    hideMenus: true
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view('portal.menus.inspections').then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            // scheduling tab
            .state('portal.menus.scheduling', {
                url: '/scheduling',
                templateUrl: 'templates/inspections-scheduling/inspections-scheduling.html',
                controller: 'InspectionsScheduling',
                params: {
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.schedule', {
                url: '/schedule',
                templateUrl: 'templates/inspections-schedule/inspections-schedule.html',
                controller: 'InspectionsSchedule',
                params: {
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view('portal.menus.scheduling').then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
    }])
;